import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
// import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
// import {
//   EndpointSalesReports,
//   createAPIEndpointSalesReports,
// } from "../../../Services/ReportsAll/SalesReportService";
import { Calendar } from "primereact/calendar";
import Axios from "../../../api/Axios";
import Loader from "../../../Components/Loader";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
const StockCard = () => {
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [loadingxl, setLoadingxl] = useState(false);
    const [productlst, setProductlst] = useState([]);
    const [fileType, setFileType] = useState("csv");
    const [selectproductlst, setSelectproductlst] = useState([]);
    const [rptType, setRptType] = useState("Summary");
    const [checkedAll, setCheckedAll] = useState(false);

    const fileTypes = [
        { label: "CSV", value: "csv" },
        { label: "XLSX", value: "xlsx" },
    ];

    const categories = [
        { name: "Pack", key: "P" },
        { name: "Ltr", key: "L" },
    ];
    const [selectedCategories, setSelectedCategories] = useState([{ name: "Pack", key: "P" }]);

    const onCategoryChange = (e) => {
        let _selectedCategories = [...selectedCategories];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedCategories(_selectedCategories);
    };

    const handleExportExcel = async () => {
        let daycount = Math.round(
            (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24)
        );
        if (daycount > 31) {
            toast.warning("Maximum 31 Days Selection is Allowed !!", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (selectedCategories.length > 1) {
            toast.warning("Please Select Pack or Ltr", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (selectedCategories.length == 0) {
            toast.warning("Please Select one Pack or Ltr", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (selectproductlst.length == 0 && !checkedAll) {
            toast.warning("Please atleast one product", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        let prodlist = selectproductlst
            ?.map((item) => `${item.MASK_PROD_ID}`)
            .join(",");
        let chkltr = selectedCategories[0].key == "P" ? "P" : "L";
        let product = checkedAll ? "All" : prodlist;
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        try {
            setLoadingxl(true);
            //   /api/StockReport/StockCardRpt
            const cnFocurl = "StockReport/StockCardRpt?";
            const cnFocCustData = `${cnFocurl}CompId=${auth.CompId}&userId=${auth.UserId}&startDate=${fromDateRange}&endDate=${toDateRange}&reportType=${rptType}&pckOrltr=${chkltr}&prodIds=${product}`;
            console.log(cnFocCustData);
            let dataresponse = await Axios.get(cnFocCustData);
            if (dataresponse?.data?.StockDataNI.length > 0) {
                let unqname =
                    fileType == "csv"
                        ? rptType == "Summary" ? `StockCard_Summary${GetDateFormat()}.csv` : `StockCard_Detail${GetDateFormat()}.csv`
                        : rptType == "Summary" ? `StockCard_Summary${GetDateFormat()}.xlsx` : `StockCard_Detail${GetDateFormat()}.xlsx`;
                downloadExcel(dataresponse?.data.StockDataNI, unqname);
            } else {
                toast.warning("No data found", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
            //   setProductlst(dataresponse.data);
        } catch (error) {
            console.log(error);
            toast.warning(`${error.response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setLoadingxl(false);
        }
    };

    const auth = storage.getLocal("user");

    const onPageLoad = async () => {
        try {
            setLoading(true);
            const cnFocurl = "StockReport/ProductList?";
            const cnFocCustData = `${cnFocurl}UOMType=4&DivnId=LUB|C&StockType=1&HoldProdId=''`;
            let dataresponse = await Axios.get(cnFocCustData);
            setProductlst(dataresponse.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        onPageLoad();
    }, []);

    if (loading) {
        return (
            <>
                <Loader />
            </>
        );
    }

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <h3 className="py-2">Stock Card</h3>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="text-end mb-2">
                        <div className="display-b me-2">
                            <Dropdown
                                value={fileType}
                                options={fileTypes}
                                onChange={(e) => setFileType(e.value)}
                                optionLabel="label"
                                placeholder="Select a file type"
                            />
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleExportExcel}
                            disabled={loadingxl}
                        >
                            {loadingxl ? "Loading..." : "Export"}{" "}
                            {loadingxl ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <Fa.FaDownload className="ms-2" />
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <section className="sales-box">
                        <form>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                    <label className="form-label">From Date</label>
                                    <Calendar
                                        onChange={(e) => {
                                            setFromDate(e.target.value);
                                        }}
                                        showIcon
                                        value={fromDate}
                                        min="2010-01-01"
                                        dateFormat="dd/mm/yy"
                                    />
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                    <label className="form-label">To Date</label>
                                    <Calendar
                                        value={toDate}
                                        onChange={(e) => setToDate(e.value)}
                                        showIcon
                                        min="2010-01-01"
                                        dateFormat="dd/mm/yy"
                                    />
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12 mb-3 ">
                                    <div className="col-lg-12 col-md-3 col-sm-12 pb-2 bottomBorder">
                                        <div className="flex align-items-center d-inline me-3 pt-2">
                                            <Checkbox
                                                name="All Products"
                                                value="All Products"
                                                onChange={(e) => setCheckedAll(e.checked)}
                                                checked={checkedAll}
                                            ></Checkbox>

                                            <label htmlFor="ingredient1" className="ml-2">
                                                All Products
                                            </label>
                                        </div>
                                    </div>

                                    <div className="mt-2">
                                        {categories.map((category) => {
                                            return (
                                                <div key={category.key} className="d-inline-flex">
                                                    <Checkbox
                                                        inputId={category.key}
                                                        name="category"
                                                        value={category}
                                                        onChange={onCategoryChange}
                                                        checked={selectedCategories.some(
                                                            (item) => item.key === category.key
                                                        )}
                                                    />
                                                    <label htmlFor={category.key} className="me-2">
                                                        {category.name}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                    <label className="form-label d-block">Report Type</label>
                                    <div className="flex align-items-center d-inline me-3">
                                        <RadioButton
                                            inputId="RptType"
                                            name="RptType"
                                            value="Summary"
                                            onChange={(e) => setRptType(e.value)}
                                            checked={rptType === "Summary"}
                                        />
                                        <label htmlFor="RptType" className="ms-2">
                                            Summary
                                        </label>
                                    </div>
                                    <div className="flex align-items-center d-inline">
                                        <RadioButton
                                            inputId="RptType"
                                            name="RptType"
                                            value="Detail"
                                            onChange={(e) => setRptType(e.value)}
                                            checked={rptType === "Detail"}
                                        />
                                        <label htmlFor="RptType" className="ms-2">
                                            Detail
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </div>
                {!checkedAll && (
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="DataTable">
                            <DataTable
                                value={productlst}
                                paginator
                                selection={selectproductlst}
                                onSelectionChange={(e) => {
                                    setSelectproductlst(e.value);
                                }}
                                showSelectAll={false}
                                rows={10}
                                filterDisplay="row"
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                showGridlines
                                selectionMode="checkbox"
                                scrollable
                                stripedRows
                                emptyMessage="No Record found"
                            >
                                <Column
                                    selectionMode="multiple"
                                    headerStyle={{ width: "3em" }}
                                />

                                <Column
                                    field="DESCRIPTION"
                                    header="List of Products"
                                    style={{ minWidth: "17rem" }}
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                            </DataTable>
                        </div>
                    </div>
                )}
            </div>

            <section className="">
                <div className="col-lg-12 col-md-12 col-sm-12"></div>
            </section>
        </div>
    );
};

export default StockCard;
